// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"sR-z","categoryName":"tR-z","categoryNameSearchHeader":"uR-z","categoryContent":"vR-z","bottomAligned":"wR-z","image":"xR-z","imageNoBackground":"yR-z"};